var particle = require('./particle');
var PIXI = require('pixi.js');

var Shrapnel = function(game,x, y, a, add_smoke, laser, fade) {
    this.game = game;
    this.add_smoke = add_smoke;
    this.x = x;
    this.y = y;
    this.a = a;
    this.my = 0;
    this.go = false;
    this.start = Date.now();
    this.last_particle = Date.now();
    this.laser = !!laser;
    if (this.laser) {
        var img = this.game.textures['laser'];
        this.body = game.makeBody({x: x, y: y, width: .25, height: 2, parent: this});
    } else {
        var img = this.game.textures['shrap' + Math.ceil(Math.random() * 3)];
        this.body = game.makeBody({x: x, y: y, width: .5, height: .5, parent: this});
    }
    this.sprite = new PIXI.Sprite(img);
    this.sprite.scale.set(.333, .333);
    this.sprite.anchor.x = .5;
    this.sprite.anchor.y = .5;
    this.game.stage.addChild(this.sprite);
    //this.body.m_body.SetPosition(200,200);
    //this.body.x = x;
    //this.body.y = y;
    this.animate = function(dt, now) {
        var pos = this.body.GetPosition();
        if(pos.x * game.scale > this.game.width) {
            pos.x = 0;
            this.body.SetPosition(pos);
        } else if (pos.x < 0) {
            pos.x = this.game.width / game.scale;
            this.body.SetPosition(pos);
        }
        var vel = this.body.GetLinearVelocity();
        var now = Date.now();
        if(this.add_smoke && now - this.start < 1200 && now - this.last_particle > 50) {
            var p = new particle.Particle(game, game.textures.smoke);
            p.reset(
                pos.x * game.scale,
                pos.y * game.scale,
                Math.random() * 50 - 25,
                Math.random() * 50 - 25,
                .15, .2, .5, -.2,
                Math.random() * 360,
                Math.random() * 10 - 5);
            this.last_particle = now;
        }
        this.angle = this.body.GetAngle();
        this.x = pos.x * game.scale;
        this.y = pos.y * game.scale;
        if (this.laser && fade != false) {
            this.sprite.alpha -= .001 * dt;
        }
        if (this.sprite.alpha <= 0) {
            this.destroy();
        }
        this.sprite.position.x = this.x;
        this.sprite.position.y = this.y;
        this.sprite.rotation = this.angle;
        this.impact_points = {};
    };

    this.destroy = function() {
        game.world.DestroyBody(this.body);
        this.game.stage.removeChild(this.sprite);
    }
};

module.exports = Shrapnel;



//////////////////
// WEBPACK FOOTER
// ./src/shrapnel.js
// module id = 87
// module chunks = 0